import { useState, Fragment } from 'react';
import dateFormat from 'date-fns/format';
import { makeStyles } from '@material-ui/core';

import Link from '@material-ui/core/Link';
import Modal from 'components/CncUI/Modal';
import DataTable from 'components/CncUI/DataTable';
import Enums from 'constants/componentData/fmsEnums';

const useStyles = makeStyles(() => ({
  link: {
    cursor: 'pointer',
  },
  content: {
    height: 400,
  },
}));

const CognitoLogs = props => {
  const classes = useStyles();
  const { identities } = props;
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({ label: '', data: {} });

  const records = (identities || []).map(identity => ({
    ...identity,
    ids: JSON.stringify({
      search: identity.cognitoId,
      profile: identity.cognitoProfileId,
    }),
  }));

  const format = data => {
    if (!data) return '';
    const parsedData = JSON.parse(data);
    return Object.keys(parsedData).map(key => (
      <Fragment key={key}>
        <b>{key}</b>
        {`: ${parsedData[key]}`}
        <br />
      </Fragment>
    ));
  };

  const openModal = (label, data) => {
    setModalData({ label, data: JSON.parse(data || {}) });
    setOpen(true);
  };

  const modalLink = label => data => {
    if (!data) return '';
    return (
      <Link
        key={label}
        className={classes.link}
        color="secondary"
        onClick={() => openModal(label, data)}
      >
        {label}
      </Link>
    );
  };

  const fromSource = source => {
    const { dataSource } = Enums;
    switch (source) {
      case dataSource.cnc:
        return 'Start+ Offer';
      case dataSource.caps:
        return 'ETC Offer';
      default:
        return `Unknown Offer ${source}`;
    }
  };

  const formatDate = timestamp => {
    const date = new Date(parseInt(timestamp, 10));
    return dateFormat(date, 'MM/dd/yyyy HH:mm:ss');
  };

  const formatStatus = row => {
    const status = row.status === 'fail' ? 'Failed' : 'Passed';
    return row.status === 'fail' ? (
      <div>
        <strong>{status}</strong> <br />
        {row.error}
      </div>
    ) : (
      <strong>{status}</strong>
    );
  };

  const formatData = row => {
    const data = [];
    const addData = (label, info) => {
      if (!info || info === '{}') return;
      data.push(modalLink(label)(info));
      data.push(', ');
    };
    addData('User input', row.input);
    addData('Cognito search results', row.data);
    addData('Cognito assessments data', row.assessments);
    addData('Threshold used', row.threshold);
    addData('Cognito result scores', row.score);
    addData('Correct address to select', row.address);
    return data.slice(0, -1);
  };

  const rows = (records || []).map(row => {
    return {
      date: row.createdAt,
      ids: format(row.ids),
      loginId: row.loginId,
      from: fromSource(row.source),
      status: formatStatus(row),
      data: formatData(row),
    };
  });

  const columns = [
    { field: 'date', value: ({ date }) => formatDate(date) },
    { field: 'ids', label: "Cognito ID's" },
    { field: 'loginId', label: 'User Okta ID' },
    { field: 'from' },
    { field: 'status' },
    { field: 'data', label: 'All Identity Information' },
  ];

  return (
    <>
      <DataTable
        transparent
        columns={columns}
        data={rows}
        pageSize={5}
        sort="date"
        order="desc"
      />
      <Modal open={open} onClose={() => setOpen(false)}>
        <Modal.Title>{modalData.label}</Modal.Title>
        <Modal.Content className={classes.content}>
          <pre>{JSON.stringify(modalData.data, null, 2)}</pre>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default CognitoLogs;
